import * as _ from "lodash";

export class LocationModel {
    public id: string | number | undefined;
    public name: string | null = null;
    public latitude: string | null = null;
    public longitude: string | null = null;
    public locationtype: string | null = null;
    public description: string | null = null;
    public address: string | null = null;

    public canvassed: number;
    public uninterested: number;
    public total: number;

    constructor(locationData?: any) {
        if (locationData) {
            this.setData(locationData);
        }
    }

    getID(): string | number | undefined {
        return this.id;
    }

    setData(locationData: any): void {
        let loc = _.merge(locationData, locationData.attributes);
        delete loc.attributes;
        this.canvassed = this.canvassed || 0;
        this.uninterested = this.uninterested || 0;
        this.total = this.total || this.uninterested + this.canvassed;
        _.merge(this, loc);
    }
}
